<template>
  <v-row>
    <v-col cols="12">
      <v-row class="sec4">
        <v-col cols="12" md="5" sm="12" lg="6" xl="6" class="sec4_left">
          <v-img
            contain
            :height="$vuetify.breakpoint.mobile ? 300 : 600"
            :max-width="$vuetify.breakpoint.mobile ? 250 : 600"
            :lazy-src="require('@/assets/img/problem.png')"
            :src="require('@/assets/img/problem.png')"
          />
        </v-col>
        <v-col cols="12" md="5" sm="12" lg="6" xl="6" class="sec4-right">
          <span class="sec4-right_title">Live Tournament Betting</span>
          <div class="sec4-right_text">
            <p>
              Good Game Platform features tournaments from your favourite eSports 
              and sports leagues around the world. With governance, you can help
              shape Good Game's future by voting in the tournaments you want to
              watch and bet on.
            </p>

            <p>
              Use the Good Game Token to create your own 
              tournaments and and bet on yourself and on your friends!
            </p>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "LiveTournaments",
};
</script>

<style>
</style>